import React, { useEffect, useState } from 'react';
import { announcementApi } from '../lib/api';

const AnnouncementMarquee = () => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    announcementApi.get().then(setCfg).catch(() => setCfg(null));
  }, []);

  if (!cfg || !cfg.is_active || !cfg.text || !cfg.text.trim()) return null;

  // Duplicate the text track so the -50% loop is seamless.
  const items = Array.from({ length: 8 }, (_, i) => (
    <span key={i} className="velouva-marquee__item text-[11px] sm:text-xs tracking-[0.22em] uppercase">
      {cfg.text}
    </span>
  ));

  return (
    <div
      data-testid="announcement-marquee"
      className="w-full overflow-hidden"
      style={{ backgroundColor: cfg.bg_color || '#1a1410', color: cfg.text_color || '#f5f1e6' }}
    >
      <div className="py-2 relative flex overflow-hidden">
        <div className="velouva-marquee" style={{ '--marquee-duration': `${cfg.speed_seconds || 30}s` }}>
          {items}
          {items}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementMarquee;
